var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0026 2.66927C5.05709 2.66927 2.66927 5.05709 2.66927 8.0026C2.66927 10.9481 5.05709 13.3359 8.0026 13.3359C10.9481 13.3359 13.3359 10.9481 13.3359 8.0026C13.3359 5.05709 10.9481 2.66927 8.0026 2.66927ZM1.33594 8.0026C1.33594 4.32071 4.32071 1.33594 8.0026 1.33594C11.6845 1.33594 14.6693 4.32071 14.6693 8.0026C14.6693 11.6845 11.6845 14.6693 8.0026 14.6693C4.32071 14.6693 1.33594 11.6845 1.33594 8.0026Z",
    fill: "#7DCC18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4951 8.10717C11.4951 8.47536 11.1966 8.77384 10.8284 8.77384L7.72386 8.77384C7.35567 8.77384 7.05719 8.47536 7.05719 8.10717L7.05719 5.55489C7.05719 5.1867 7.35567 4.88822 7.72386 4.88822C8.09205 4.88822 8.39052 5.1867 8.39052 5.55489L8.39052 7.44051L10.8284 7.44051C11.1966 7.44051 11.4951 7.73898 11.4951 8.10717Z",
    fill: "#7DCC18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.b698b97b3c530889fb688a4bda68bcda.svg";
export { ForwardRef as ReactComponent };